import React from 'react'

import { Card } from '@grandvisionhq/common'
import { useIntl } from '@grandvisionhq/state'

import { SummaryProps } from './types'

const UserDataAddress = ({ actions, values = {} }: SummaryProps) => {
  const { getLabel } = useIntl()

  return (
    <Card>
      <Card.Content>
        {actions?.onEdit && (
          <Card.Actions>
            <Card.Button onClick={actions.onEdit} children={getLabel('common.actions.edit')} />
          </Card.Actions>
        )}
        <Card.Text variant="body-head">
          {values.salutation} {values.firstName} {values.lastName}
        </Card.Text>
        <Card.Text>{values.streetName}</Card.Text>
        {values.additionalStreetInfo && <Card.Text>{values.additionalStreetInfo}</Card.Text>}
        {values.additionalAddressInfo && <Card.Text>{values.additionalAddressInfo}</Card.Text>}
        <Card.Text>{values.city}</Card.Text>
        <Card.Text>{values.region}</Card.Text>
        <Card.Text>{values.postalCode}</Card.Text>
        <Card.Text>United Kingdom</Card.Text>
      </Card.Content>
    </Card>
  )
}

const SubscriptionAddress = ({ actions, values = {}, title }: SummaryProps) => {
  const { getLabel } = useIntl()

  return (
    <Card>
      <Card.Content>
        {title && <Card.Text variant="body-head">{title}</Card.Text>}
        {actions?.onEdit && (
          <Card.Actions>
            <Card.Button onClick={actions.onEdit} children={getLabel('common.actions.edit')} />
          </Card.Actions>
        )}
        <Card.Text variant="body-head">
          {values.firstName} {values.lastName}
        </Card.Text>
        <Card.Text>{values.addressLine1}</Card.Text>
        {values.addressLine2 && <Card.Text>{values.addressLine2}</Card.Text>}
        <Card.Text>{values.city}</Card.Text>
        <Card.Text>{values.county}</Card.Text>
        <Card.Text>{values.postalCode}</Card.Text>
        <Card.Text>United Kingdom</Card.Text>
      </Card.Content>
    </Card>
  )
}

const AddressSummary = ({ actions, values = {}, type, title }: SummaryProps) => {
  return !!values.streetName ? (
    <UserDataAddress actions={actions} values={values} type={type} />
  ) : (
    <SubscriptionAddress actions={actions} values={values} type={type} title={title} />
  )
}

export default AddressSummary
